// extracted by mini-css-extract-plugin
export default {"tableHeader":"DataGrid_tableHeader__tJKUk","striped_table":"DataGrid_striped_table__6QdwX"};